import React from "react";

const PDFFileIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg width="26" height="29" viewBox="0 0 26 29" fill="none" {...props}>
    <path
      d="M6.17188 22.2503V19.0212M6.17188 19.0212V17.0837C6.17188 16.4748 6.17188 16.1703 6.37049 15.9812C6.56911 15.792 6.88878 15.792 7.52812 15.792H8.43229C9.36859 15.792 10.1276 16.5149 10.1276 17.4066C10.1276 18.2983 9.36859 19.0212 8.43229 19.0212H6.17188ZM24.2552 15.792H22.5599C21.4943 15.792 20.9615 15.792 20.6305 16.1073C20.2995 16.4225 20.2995 16.9299 20.2995 17.9448V19.0212M20.2995 22.2503V19.0212M20.2995 19.0212H23.125M17.474 19.0212C17.474 20.8046 15.9559 22.2503 14.0833 22.2503C13.6608 22.2503 13.4495 22.2503 13.2922 22.1638C12.9154 21.9566 12.9531 21.5373 12.9531 21.1739V16.8684C12.9531 16.505 12.9154 16.0857 13.2922 15.8785C13.4495 15.792 13.6608 15.792 14.0833 15.792C15.9559 15.792 17.474 17.2377 17.474 19.0212Z"
      stroke="#8065C9"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5026 27.4165H10.9837C6.77128 27.4165 4.66508 27.4165 3.2024 26.386C2.78332 26.0907 2.41127 25.7405 2.09755 25.3461C1.00261 23.9695 1.0026 21.9872 1.0026 18.0226V14.7347C1.0026 10.9073 1.00261 8.99354 1.60832 7.4651C2.58207 5.00792 4.64141 3.06973 7.25215 2.15325C8.87612 1.58317 10.9094 1.58317 14.9761 1.58317C17.2999 1.58317 18.4618 1.58317 19.3898 1.90893C20.8816 2.43263 22.0584 3.54017 22.6148 4.94427C22.9609 5.81767 22.9609 6.91122 22.9609 9.09832V11.9165"
      stroke="#8065C9"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.00521 14.4995C1.00521 12.1216 2.93287 10.194 5.31076 10.194C6.17074 10.194 7.18459 10.3446 8.02072 10.1206C8.76363 9.92154 9.3439 9.34126 9.54297 8.59836C9.76701 7.76223 9.61632 6.74837 9.61632 5.8884C9.61632 3.51051 11.544 1.58285 13.9219 1.58285"
      stroke="#8065C9"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export default PDFFileIcon;
